export class HistoryModel {

    /**
     * ä¾é»é»è©±
     */
    phoneNumber : string ;

    /**
     * ä¾é»æé
     */
    datetime : Date;

    /**
     * è©±åçæ
     */
    status : string ;

    /**
     *  æçºæé
     */
    continueTime : string;
}